import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const ProjectDeleteModalUI = ({context, messageList, project, successMsg, errorList, setErrorList,
    // modes
    deleteMode, submitted,
    // event handlers
    onSubmit, onCancel,
  }) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey={project.projectType === 'project' ? 'c_delete_project' : 'c_delete_template'}
    buttonMessageKey='c_delete'
    cancelMessageKey='c_cancel'

    isOpen={deleteMode}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onRequestClose={onCancel}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <MessageUI messageList={messageList}
      messageKey={project.projectType === 'project' ? 'c_delete_project_conf' : 'c_delete_template_conf'}
      args={[project.projectName]}
    />
  </ModalFormUI>

export default ProjectDeleteModalUI
